module.exports = __webpack_public_path__ + "img/bathIcon.1ea91900.png";